import axios from "@/plugins/axios";
import { formatDateTime } from "@/utils/datehelper";
export const state = () => ({
  shop: 1,
  products: [],
  services: [],

  suspend_lists: [],
  totalAmount: 0,
  isAmountRound: false,
  roundingAmount: 0,
  customer: [],
  customer_payments: [],
  customer_manual_payment: 0,
  customer_discount_payment: 0,
  sale_type: "Cash",
  isSubmittedSale: false,
  hasPrinted: false,

  addedSale: {},

  // Below variable using for the print-bill only
  isPrint: false,
  quantity: 0,
  productsForBill: [],

  customerCashPaymentForBill: 0,
  customerCardPaymentForBill: 0,
  customerChequePaymentForBill: 0,
  customerManualPaymentForBill: 0,
  totalDiscountForBill: 0,
  balanceForBill: 0,
  servicesForBill: [],
});

export const mutations = {
  SET_PRODUCT(state, payload) {
    for (var i = 0; i < payload.length; i++) {
      // payload[i].price = payload[i].quantity * payload[i].batch.selling_price;
      payload[i].price = payload[i].batch.selling_price;
    }
    state.products = payload;
  },
  ADD_SERVICES(state, payload) {
    state.services.push(payload);
  },

  ADD_PRODUCT(state, payload) {
    var addedProducts = state.products;

    const found = addedProducts.some(
      (item) =>
        item.batch.id == payload.batch.id &&
        item.id == payload.id &&
        item.unit.id == payload.unit.id
    );
    // If product id already exists, quantity will be increase
    if (found) {
      var index = addedProducts.findIndex(
        (item) =>
          item.batch.id == payload.batch.id &&
          item.id == payload.id &&
          item.unit.id == payload.unit.id
      );
      addedProducts[index].quantity = addedProducts[index].quantity + 1;
    } else {
      payload.index = addedProducts.length;
      addedProducts.push(payload);
    }
    state.products = addedProducts;
  },
  UPDATE_PRODUCT(state, { index, data }) {
    var addedProducts = state.products;
    addedProducts[index] = data;
    //  const found = addedProducts.some(
    //    (item) =>
    //      item.batch.id == payload.batch.id &&
    //      item.id == payload.id &&
    //      item.unit.id == payload.unit.id
    //  );
    //  // If product id already exists, quantity will be increase
    //  if (found) {
    //    var index = addedProducts.findIndex(
    //      (item) =>
    //        item.batch.id == payload.batch.id &&
    //        item.id == payload.id &&
    //        item.unit.id == payload.unit.id
    //    );
    //    addedProducts[index].quantity = addedProducts[index].quantity + 1;
    //  } else {
    //    addedProducts.push(payload);
    //  }
    //state.products = [];
    state.products = addedProducts;
  },
  REMOVE_SERVICE(state, index) {
    var addedservices = state.services;
    addedservices.splice(index, 1);
    state.services = addedservices;
  },
  REMOVE_PRODUCT(state, index) {
    var addedProducts = state.products;
    addedProducts.splice(index, 1);
    state.products = addedProducts;
  },
  CANCEL_BILL(state, index) {
    state.products = [];
    state.services = [];
    state.customer_payments = [];
    state.customer_amount = 0;
    state.customer_manual_payment = 0;
    state.isSubmittedSale = false;
    state.addedSale = {};
  },
  CLEAR_ALL_BILL(state) {
    state.products = [];
    state.services = [];
    state.customer_payments = [];
    state.customer_amount = 0;
    state.customer_manual_payment = 0;
    state.isSubmittedSale = false;
    state.addedSale = {};
    state.isPrint = false;
    state.productsForBill = [];
    state.hasPrinted = false;
  },
  SET_SUSPEND_LISTS(state, payload) {
    // ;
    // var data = payload;
    // for (var item in data) {
    //   // item.data = JSON.parse(item);
    //   data[item].data = JSON.parse(data[item].data);
    // }
    state.suspend_lists = payload;
  },
  SET_CUSTOMER(state, payload) {
    state.customer = payload;
    state.sale_type = "Cash";
  },
  SET_BILLER(state, payload) {
    state.biller = payload;
  },
  SET_ROUNDING_AMOUNT(state, payload) {
    state.isAmountRound = true;
    state.roundingAmount = payload;
  },
  CHANGE_QUANTITY(state, payload) {
    var products = state.products;
    products[payload.index].quantity = payload.quantity;
    state.products = products;
  },
  CHANGE_SERVICE_AMOUNT(state, payload) {
    var products = state.services;
    products[payload.index].amount = payload.amount;
    state.services = products;
  },
  APPLY_SALE(state, payload) {
    state.products = payload;
  },
  SET_CUSTOMER_AMOUNT(state, payload) {
    state.customer_amount = payload;
  },
  SET_PAYMENTS(state, payload) {
    state.customer_payments = payload;
  },
  SET_CUSTOMER_MANUAL_AMOUNT(state, payload) {
    state.customer_manual_payment = payload;
  },
  SET_CUSTOMER_DISCOUNT_AMOUNT(state, payload) {
    state.customer_discount_payment = payload;
  },
  SET_SALE_TYPE(state, payload) {
    state.sale_type = payload;
  },
  SET_ISSUBMITTEDSALE(state, payload) {
    state.isSubmittedSale = payload;
  },

  SET_ADDED_SALE(state, payload) {
    state.addedSale = payload;
  },
  SET_PRINT_DATA_STATUS(state, payload) {
    state.isPrint = payload;
  },
  SET_BILL_PRODUCTS_TO_PRINT_DATA(state) {
    state.productsForBill = JSON.parse(JSON.stringify(state.products));
    state.servicesForBill = JSON.parse(JSON.stringify(state.services));

    state.customerCashPaymentForBill = state.customer_payments
      .filter((p) => p.payment_type === "Cash")
      .reduce((a, b) => a + parseFloat(b.amount), 0);

    state.customerCardPaymentForBill = state.customer_payments
      .filter((p) => p.payment_type === "Card")
      .reduce((a, b) => a + parseFloat(b.amount), 0);

    state.customerChequePaymentForBill = state.customer_payments
      .filter((p) => p.payment_type === "Cheque")
      .reduce((a, b) => a + parseFloat(b.amount), 0);

    state.customerManualPaymentForBill = state.customer_manual_payment;
    state.totalDiscountForBill = state.customer_discount_payment;

    state.balanceForBill =
      state.customer_manual_payment - state.customerCashPaymentForBill;

    state.isPrint = true;
  },

  SET_RESPONSE_SERVICES(state, payload) {
    state.services = payload;
  },
};
export const actions = {
  submitSale({ state, commit, getters, rootGetters }, payload) {
    return new Promise((resolve, reject) => {
      // commit("SET_PAYMENTS", payload);
      var items = state.products.map((item) => {
        var itemData = {
          product_id: item.id,
          batch_id: item.batch.id,
          unit_id: item.unit.id,
          quantity: item.quantity,
          bargain_discount: item.batch.isBargained
            ? item.batch.bargained_amount
            : 0,
          amount: item.price,
          comment: "",
        };
        return itemData;
        // if (item.batch.isBargained) {
        //   itemData.bargain_discount=item.batch.isBargained
        // }
      });
      var services = state.services.map((item) => {
        var itemData = {
          service_id: item.id,
          bargain_discount: 0,
          amount: item.amount,
        };
        return itemData;
        // if (item.batch.isBargained) {
        //   itemData.bargain_discount=item.batch.isBargained
        // }
      });
      var data = {
        date: formatDateTime(new Date()),
        rounding: state.isAmountRound ? state.roundingAmount : 0,
        customer_id: state.customer.id,
        shop_id: rootGetters["shops/GetShopId"],
        note: "",
        staff_note: "",
        items: items,
        services: services,
        payment: payload,
        sale_type: state.sale_type,
        discount_amount: state.customer_discount_payment,
        // grand_total: getters.GetTotalAmount,
        // total: "",
        // total_items: getters.GetProductsCount,
      };
      axios
        .post("pos/sales", data)
        .then((res) => {
          commit("SET_ADDED_SALE", res.data);
          commit("SET_RESPONSE_SERVICES", res.data.saleServices);
          commit("SET_ISSUBMITTEDSALE", true);
          // if (res.status == 200 && res.data.data) {
          //   commit("SET_SUSPEND_LISTS", res.data.data);
          // } else {
          //   commit("SET_SUSPEND_LISTS", []);
          // }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  cancelSale({ commit }, payload) {
    let saleId = payload.id;
    delete payload.id;
    return new Promise((resolve, reject) => {
      axios
        .patch(`pos/sales/${saleId}/change-status`, payload)
        .then((res) => {
          commit("CANCEL_BILL", []);
          commit("SET_ISSUBMITTEDSALE", false);
          commit("SET_ADDED_SALE", {});
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  UpdateProductArray({ commit }, product) {
    commit("SET_PRODUCT", product);
  },
  AddProduct({ commit }, product) {
    commit("ADD_PRODUCT", product);
  },
  AddService({ commit }, PAYLOAD) {
    commit("ADD_SERVICES", PAYLOAD);
  },
  setCurrentCustomer({ commit }, payload) {},
  removeProduct({ commit }, index) {
    commit("REMOVE_PRODUCT", index);
  },
  removeService({ commit }, index) {
    commit("REMOVE_SERVICE", index);
  },
  cancelBill({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      if (!state.hasPrinted) {
        state.hasPrinted = true;
        commit("CANCEL_BILL");
      }
      resolve();
    });
  },

  fetchSuspendList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("pos/sales/drafts")
        .then((res) => {
          if (res.status == 200 && res.data.data) {
            commit("SET_SUSPEND_LISTS", res.data.data);
          } else {
            commit("SET_SUSPEND_LISTS", []);
          }
          resolve(res.data.data);
        })
        .catch((err) => {
          commit("SET_SUSPEND_LISTS", []);
          reject(err);
        });
    });
  },
  saveSalesAsDraft({ state, commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("pos/sales/save-as-draft", {
          data: payload.data,
          comment: payload.comment,
        })
        .then((res) => {
          // if (res.status == 200 && res.data != null) {
          //   commit("SET_SUSPEND_LISTS", res.data.data);
          // } else {
          //   commit("SET_SUSPEND_LISTS", []);
          // }
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  RemoveSuspendSale: function({}, payload) {
    return new Promise((resolve, reject) => {
      axios
        .delete("pos/sales/drafts/" + payload)
        .then((res) => {
          // if (res.status == 200 && res.data != null) {
          //   commit("SET_SUSPEND_LISTS", res.data.data);
          // } else {
          //   commit("SET_SUSPEND_LISTS", []);
          // }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  submitSalePayment({ state, commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`sales/${payload.id}/payments`, payload.payment)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export const getters = {
  GetAddedSale: function(state) {
    return state.addedSale;
  },
  GetIsSubmittedSale: function(state) {
    return state.isSubmittedSale;
  },
  GetTotalAmount: function(state) {
    var products = state.isPrint ? state.productsForBill : state.products;
    if (products.length == 0 && state.services.length == 0) return 0;

    var total = products.reduce(function(a, b) {
      if (b.batch) {
        return (
          a +
          b.quantity *
            ((b.isMinPriceEnabled ? b.batch.min_price : b.batch.selling_price) -
              b.batch.bargained_amount)
        );
      } else {
        return (
          a +
          b.quantity *
            (b.isMinPriceEnabled ? b.batch.min_price : b.batch.selling_price)
        );
      }
    }, 0);
    return total;
  },

  GetServiceTotalAmount: function(state) {
    if (state.services.length == 0) return 0;

    var total = state.services.reduce(function(a, b) {
      return parseFloat(a) + parseFloat(b.amount);
    }, 0);
    return total;
  },

  GetDiscountAmount: function(state) {
    var products = state.isPrint ? state.productsForBill : state.products;

    if (products.length == 0) return 0;

    var total = products.reduce(function(a, b) {
      if (b.isMinPriceEnabled) {
        return a + b.quantity * parseInt(b.batch.bargained_amount);
      } else if (b.batch) {
        return a + b.quantity * parseInt(b.batch.bargained_amount);
      } else {
        return a;
      }
    }, 0);
    return total;
  },

  GetRoundingAmount: function(state) {
    return state.roundingAmount;
  },
  GetProductsCount: function(state) {
    var products = state.isPrint ? state.productsForBill : state.products;

    return products.length;
  },
  GetSelectedCustomer: function(state) {
    return state.customer;
  },
  GetCustomerManualAmount: function(state) {
    return state.customer_manual_payment;
  },
  GetCustomerDiscountForTotalAmount: function(state) {
    return state.customer_discount_payment;
  },
  GetCustomerCashAmount: function(state) {
    if (state.customer_payments.length == 0) {
      return 0;
    }

    var CashList = state.customer_payments.filter(
      (item) => item.payment_type == "Cash"
    );
    var CashAmountList = CashList.map((item) => item.amount);

    var cash_amount = 0;
    if (CashAmountList.length != 0) {
      cash_amount = CashAmountList.reduce(function(a, b) {
        return parseFloat(a) + parseFloat(b);
        // if (b.payment_type == "Card") {
        //   return parseFloat(a) + parseFloat(b.amount);
        // } else {
        //   return a;
        // }
      });
    }
    return cash_amount;
  },
  GetCustomerCardAmount: function(state) {
    if (state.customer_payments.length == 0) {
      return 0;
    }

    var CardList = state.customer_payments.filter(
      (item) => item.payment_type == "Card"
    );
    var CardAmountList = CardList.map((item) => item.amount);

    var card_amount = 0;
    if (CardAmountList.length != 0) {
      card_amount = CardAmountList.reduce(function(a, b) {
        return parseFloat(a) + parseFloat(b);
        // if (b.payment_type == "Card") {
        //   return parseFloat(a) + parseFloat(b.amount);
        // } else {
        //   return a;
        // }
      });
    }
    return card_amount;
  },
  GetCustomerChequeAmount: function(state) {
    if (state.customer_payments.length == 0) {
      return 0;
    }

    var ChequeList = state.customer_payments.filter(
      (item) => item.payment_type == "Cheque"
    );
    var ChequeAmountList = ChequeList.map((item) => item.amount);

    var card_amount = 0;
    if (ChequeAmountList.length != 0) {
      card_amount = ChequeAmountList.reduce(function(a, b) {
        return parseFloat(a) + parseFloat(b);
        // ;
        // if (b.payment_type == "Card") {
        //   return parseFloat(a) + parseFloat(b.amount);
        // } else {
        //   return a;
        // }
      });
    }
    return card_amount;
  },
  GetSaleType: function(state) {
    return state.sale_type;
  },
  GetSelectedProductUnitsAndQuantity: (state) => (
    productId,
    selectedUnitId
  ) => {
    if (state.products.length == 0) {
      return [];
    }
    let takenUnits = [];

    state.products
      .filter((p) => p.id == productId)
      .forEach((element) => {
        if (
          element.quantity != null &&
          element.quantity != "" &&
          element.unit.id != selectedUnitId
        ) {
          takenUnits.push({
            unit_id: element.unit.id,
            quantity: element.quantity,
            batch_id: element.batch.id,
          });
        }
      });

    return takenUnits;
  },
  GetWarehouseProducts: function(state) {
    if (state.products.length == 0) return 0;

    let group = state.products.reduce((r, a) => {
      r[a.warehouse.id] = [...(r[a.warehouse.id] || []), a];
      return r;
    }, {});
    let warehouses = [];

    Object.keys(group).forEach((key) => {
      let element = group[key];
      warehouses.push({
        warehouse: element[0].warehouse,
        products: element,
      });
    });

    return warehouses;
  },
  GetPrintProductsData: function(state) {
    return state.isPrint ? state.productsForBill : state.products;
  },
  GetPrintCustomerCashAmount: (state) => state.customerCashPaymentForBill,
  GetPrintCustomerCardAmount: (state) => state.customerCardPaymentForBill,
  GetPrintCustomerChequeAmount: (state) => state.customerChequePaymentForBill,
  GetPrintCustomerManualAmount: (state) => state.customerManualPaymentForBill,
  GetPrintTotalDiscount: (state) => state.totalDiscountForBill,
  GetPrintBalance: (state) => state.balanceForBill,
  GetPrintServicesData: (state) => state.servicesForBill,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
